import React from 'react';
import truncate from 'truncate-markup-string';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { CARD_SUBTITLE_MAX_LENGTH } from '../../../config/constants';
import { BaseCardProps } from '../types';

const CardSubtitle: React.FC<Pick<BaseCardProps, 'subtitle'>> = (props) => {
  const { subtitle } = props;

  if (!subtitle) {
    return null;
  }

  return (
    <WysiwygField
      className="Card__subtitle"
      property="schema:text"
      html={truncate(subtitle, CARD_SUBTITLE_MAX_LENGTH, '<span>', '</span>', true)}
    />
  );
};

export default CardSubtitle;
